import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    key: 'jafun_cart',
    paths: ['cart'],
  })(store)
}
